import {
  Breakpoints,
  Select as VWSelect,
} from '@volkswagen-onehub/components-core';
import {
  GroupedSelectProps,
  SelectProps,
} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import * as React from 'react';
import styled from 'styled-components';

// set css for select component using styled components
// breakpoint under 960 should apply this to avoid being clipped the box shadow when the parent container overflows hidden
const StyleSelect = styled(VWSelect)`
  @media (max-width: ${Breakpoints.b960}px) {
    margin-inline: ${({theme}) => theme.size.border.default};
  }
`;

export function Select({
  options,
  selectedValue,
  label,
  onChange,
  testId,
  disabled,
}: SelectProps): JSX.Element {
  const onChangeHandler = React.useCallback(
    (e: React.SyntheticEvent<HTMLSelectElement>) =>
      onChange(e.currentTarget.value),
    [onChange]
  );

  return (
    <StyleSelect
      label={label}
      value={selectedValue}
      onChange={onChangeHandler}
      data-testid={testId}
      disabled={disabled}
    >
      {options.map((option) => (
        <option
          aria-selected={selectedValue === option.value}
          key={option.value}
          value={option.value}
        >
          {option.label}
        </option>
      ))}
    </StyleSelect>
  );
}

export function GroupedSelect({
  optionGroups,
  selectedValue,
  label,
  onChange,
  testId,
}: GroupedSelectProps): JSX.Element {
  const onChangeHandler = React.useCallback(
    (e: React.SyntheticEvent<HTMLSelectElement>) =>
      onChange(e.currentTarget.value),
    [onChange]
  );

  return (
    <VWSelect
      label={label}
      value={selectedValue}
      onChange={onChangeHandler}
      data-testid={testId}
    >
      {optionGroups.map((group) => (
        <optgroup label={group.label} key={group.groupId}>
          {group.options.map((option, index) => (
            <option
              aria-selected={selectedValue === option.value}
              key={`${option.value},${index}`}
              value={option.value}
            >
              {option.label}
            </option>
          ))}
        </optgroup>
      ))}
    </VWSelect>
  );
}
